/** Os números da página inicial: dinheiro por extenso ou compacto, percentual com sinal. */

export const reais = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
export const reaisInteiros = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
/** "R$ 1,74 mi", "R$ 24,3 mil": o valor grande que cabe num cartão. */
export const reaisCompactos = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  notation: 'compact',
  maximumFractionDigits: 2,
});
/** O eixo do gráfico: "R$ 20 mil". */
export const reaisDoEixo = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  notation: 'compact',
  maximumFractionDigits: 1,
});

/** 0,0138 vira "1,38%". */
export function percentual(fracao: number, casas = 2): string {
  return `${(fracao * 100).toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas })}%`;
}

/** Com sinal: "+0,81%", "−1,20%". */
export function variacaoComSinal(fracao: number): string {
  const sinal = fracao > 0 ? '+' : fracao < 0 ? '−' : '';
  return `${sinal}${percentual(Math.abs(fracao))}`;
}
